import { createSlice, current } from "@reduxjs/toolkit";

import * as Act from "./actions";

const initialState = {
  loading: false,
  userLoading: false,
  userStatistics: null,

  btncLoading: false,
  btncStatistics: null,

  energyLoading: false,
  energyStatistics: null,

  claimLoading: false,
  claimStatistics: null,

  taskLoading: false,
  taskStatistics: null,
};

const slice = createSlice({
  name: "Statistics",
  initialState: { ...initialState },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(Act.getUserStatistics.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getUserStatistics.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      userStatistics: payload,
    }));
    builder.addCase(Act.getUserStatistics.rejected, (state, action) => ({
      ...state,
      loading: false,
      userStatistics: null,
    }));
    builder.addCase(Act.getBtncStatistics.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getBtncStatistics.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      btncStatistics: payload,
    }));
    builder.addCase(Act.getBtncStatistics.rejected, (state, action) => ({
      ...state,
      loading: false,
      btncStatistics: null,
    }));
    builder.addCase(Act.getEnergyStatistics.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(
      Act.getEnergyStatistics.fulfilled,
      (state, { payload }) => ({
        ...state,
        loading: false,
        energyStatistics: payload,
      }),
    );
    builder.addCase(Act.getEnergyStatistics.rejected, (state, action) => ({
      ...state,
      loading: false,
      energyStatistics: null,
    }));
    builder.addCase(Act.getClaimStatistics.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getClaimStatistics.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      claimStatistics: payload,
    }));
    builder.addCase(Act.getClaimStatistics.rejected, (state, action) => ({
      ...state,
      loading: false,
      claimStatistics: null,
    }));
    builder.addCase(Act.getTaskStatistics.pending, (state, action) => ({
      ...state,
      loading: true,
    }));
    builder.addCase(Act.getTaskStatistics.fulfilled, (state, { payload }) => ({
      ...state,
      loading: false,
      taskStatistics: payload,
    }));
    builder.addCase(Act.getTaskStatistics.rejected, (state, action) => ({
      ...state,
      loading: false,
      taskStatistics: null,
    }));
  },
});

export default slice;
